import { setupAnalytics } from "./analytics/analytics.js";
import { setupSatoriForm } from "./contact/satori-form.js";
import { setupFaq } from "./faq/faq-page.js";
import { setupImageZoom } from "./media/image-zoom.js";
import { setupNavToggle } from "./nav/nav-toggle.js";
import { setupHeaderSession } from "./session/header-session.js";
import { setupStartGuide } from "./start-guide/slideshow.js";

/**
 * 公開ページと会員画面の外枠のフロントエンド エントリポイント。
 *
 * jQuery は使わない。**外部の部品は画像の拡大表示（PhotoSwipe）だけ。**
 * 拡大の操作は端末ごとの差が大きく、自前で書くと引き受ける範囲が広がりすぎる。
 *
 * **会員の画面の中身は React（MemberApp/）が描く。**ここに残すのは外枠（ヘッダー）と
 * 公開ページで動くものだけ——入力の検証・プラン選択・カード入力は会員の画面（MemberApp/）が持つ。
 * 料金プランのページの見積り欄も、新規申し込みと同じ部品を MemberApp の <c>estimate.tsx</c> が動かす。
 */
const start = (): void => {
    // アクセスの計測（本番の書き出しだけ。測定 ID が無ければ何もしない）
    setupAnalytics();
    setupNavToggle();
    // 静的に配った画面だけで動く（ヘッダーをログインの状態に合わせる。docs/04 §5.2.1）
    void setupHeaderSession();
    // スタートガイドの紙芝居（そのページだけ。無ければ何もしない）。<b>拡大より先に</b>——写真に拡大の印を付ける
    setupStartGuide();
    setupImageZoom();
    // よくあるご質問の検索・すべて開く／閉じる・設問へのリンク（そのページだけ。無ければ何もしない）
    setupFaq();
    // お問い合わせのページの SATORI のフォーム（そのページだけ。無ければ何もしない）
    setupSatoriForm();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
} else {
    start();
}
